module.exports = __webpack_public_path__ + "img/male.3d806d7c.svg";